export const verificarSeEhAmbienteDeProducao = () => {
  const urlAtual = window.location.href;
  return urlAtual.includes('http://inscricao.habix') || urlAtual.includes('https://inscricao.habix');
};

export const verificarSeEhAmbienteDeHomologacao = () => {
  const urlAtual = window.location.href;
  return urlAtual.includes('http://hom.inscricao.habix') || urlAtual.includes('https://hom.inscricao.habix');
};